var headerTabs;

(function() {
    'use strict';

    if (!document.querySelector('#vue-header-tabs')) {
        return;
    }

    headerTabs = new Vue({
        el: '#vue-header-tabs',
        data: function() {
            return {
                selectedTab: 0,
                tabList: null,
                initialized: false,
            };
        },
        computed: {},
        methods: {
           getTabindex: function(tab) {
                var tabIndex = 0;

                while ((tab = tab.previousSibling) != null) {
                    tabIndex++;
                }

                return tabIndex;
            },

            onTabClicked: function(ev) {
                var tabIndex = this.getTabindex(ev.target.parentNode);

                ev.preventDefault();

                if (tabIndex === this.selectedTab) {
                    return;
                }

                this.tabList[this.selectedTab].classList.remove('header__tabs-link--selected');
                this.tabList[tabIndex].classList.add('header__tabs-link--selected');
                this.selectedTab = tabIndex;

                MpEventBus.$emit('header-tab-clicked', tabIndex);
            },

            init: function() {
                if (this.initialized) {
                    return;
                }

                this.initialized = true;
                this.tabList = this.$el.querySelectorAll('.header__tabs-link');
                this.$el.addEventListener('click', this.onTabClicked);
            },
        },
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();


